/**
 * @override King Living: HeroBannerFragment extended for CF-04 (headingImage as Image only).
 */

import gql from 'graphql-tag';

import {BaseActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/base-action-links.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const HeroBannerFragment = gql`
  ${BaseActionLinksFragment}
  ${BaseHeroBannerFragment}
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseVideoFragment}

  fragment HeroBannerFragment on HeroBanner {
    ...BaseHeroBannerFragment

    backgroundMedia {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
    body {
      ...BaseRichTextBlockFragment
    }
    cta {
      ...BaseActionLinksFragment
    }
    headingImage {
      ... on Image {
        ...BaseImageFragment
      }
    }
    rightCta {
      ...BaseActionLinksFragment
    }
  }
`;
